
$(document).ready(() => {
  const currentLocation = window.location;
  const $window = $(window);

  $.fn.goalTriggerMaster = function(AJAX_DATA) {

    console.log('GOAL TRIGGER initiated');
    let ajax_url, ajax_data, ajax_componentName;
    if (AJAX_DATA) {
      ajax_url = AJAX_DATA.url;
      ajax_data = {
        goalId: AJAX_DATA.id
      };
      ajax_componentName = AJAX_DATA.name;
    } else {
      return;
    }
    $.ajax({
      type: 'GET',
      url: ajax_url,
      data: ajax_data,
      success(data) {
        console.log(`triggergoal submitted for ${  ajax_componentName  } and ID is ${  ajax_data.goalId}`);
      },
      error(response) {
        console.error(response.message);
      }
    });
  }

  $.fn.AJAX_DATA_BUILDER = function(id, ComponentName) {
    const AJAX_DATA = {
      url: '/api/sitecore/AnalyticsApi/TriggerGoal',
      id,
      name: ComponentName ? ComponentName : 'No component'
    }

    return AJAX_DATA;
  }

  $.fn.goalTriggerEventFireMaster = function(AJAX_DATA, HTML_ID, Page_Url, includeSubpages) {
    if (includeSubpages) {
      if (!window.location.pathname.toLocaleLowerCase().includes(Page_Url.toLocaleLowerCase())) {
        return;
      }
    } else if (window.location.pathname.toLocaleLowerCase() !== Page_Url.toLocaleLowerCase()) {
      return;
    }

    //Adding EventLister to required element
    if ($(HTML_ID).length) {

      $(HTML_ID).on('click', e => {
        $window.goalTriggerMaster(AJAX_DATA);
      });
    }
  }

  $window.atccGoals = [];


  //Register the trigger
  //Summary
  //goalId -> GoalId must be in GUID format string
  //goalName -> Goal name is just for logging purpose
  //elementSelector -> element Selector is a unique element Id in the page
  //pageUrl -> page where you wanna trigger the goal
  //includeSubpages -> To apply goal to subpages
  //Below method triggers the goal on the click of the element for the given page url
  // $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER(goalId as string, goalName as string), elementSelector as string, pageUrl as string, includeSubpages as boolean)

  $window.atccGoals.push({ id: '{ADC4D9D7-970D-4AF6-B372-08F6B9FB36B8}', name: 'Complete Lead Generation For Service' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[0].id, $window.atccGoals[0].name), '.eloqua-form form input[type="submit"]', '/services', true);

  $window.atccGoals.push({ id: '{F6507F9A-B1BF-49A0-AF4C-BF2B0F65614A}', name: 'Watch a Video' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[1].id, $window.atccGoals[1].name), '.video-component-with-2-ctas button', '/resources/videos', false);

  $window.atccGoals.push({ id: '{F24ECA8C-DDD4-44CC-BFB3-9CA9EB8554E7}', name: 'View Webinar' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[2].id, $window.atccGoals[2].name), '.event-detail event-detail-cta .presenters-component__button', '/resources/webinars/', true);
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[2].id, $window.atccGoals[2].name), '.presenters-component__button-wrapper .presenters-component__button', '/resources/webinars/', true);
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[2].id, $window.atccGoals[2].name), '.video-component-with-2-ctas button', '/resources/webinars/', true);

  $window.atccGoals.push({ id: '{D47D3651-2E94-410F-8D7A-B3079195DD6B}', name: 'Download Webinar as PDF' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[3].id, $window.atccGoals[3].name), '.video-component-with-2-ctas .video-component-with-2-ctas__ctas a', '/resources/webinars/', true);

  $window.atccGoals.push({ id: '{3987DCED-59C0-4CDF-AA08-688810CBE3AE}', name: 'Download Culture Guides' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[4].id, $window.atccGoals[4].name), '.downloadable-content .downloadable-content__button', '/resources/culture-guides/', true);

  $window.atccGoals.push({ id: '{D2FDA741-59F5-4DD7-8FD2-39986CE37EE1}', name: 'Download Other Resources' })
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.downloadable-content .downloadable-content__button', '/resources/application-notes/', true);

  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.resources-content-cards__single-card .resources-content-cards__single-card-image', '/resources/infographics', false);
  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.resources-content-cards__single-card .resources-content-cards__single-card-title', '/resources/infographics', false);

  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.downloadable-content .downloadable-content__button', '/resources/posters/', true);

  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.video-component-with-2-ctas__container .video-component-with-2-ctas__ctas a', '/resources/presentations/', true);

  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.downloadable-content .downloadable-content__button', '/resources/technical-documents/', true);

  $window.goalTriggerEventFireMaster($window.AJAX_DATA_BUILDER($window.atccGoals[5].id, $window.atccGoals[5].name), '.downloadable-content .downloadable-content__button', '/resources/white-papers/', true);


});
